import { __decorate, __metadata } from "tslib";
import { Vue, Component, Inject, Ref } from 'vue-property-decorator';
import _ from 'lodash';
import { getQueryIdpsApi } from 'library-components/apis/login/login';
import { isLoadingValue, restoreSelectedIDP, saveSelectedIDP, withLoadingValue, withoutLoadingValue } from '@/infrastructure/utils/idpHelper';
import { getVar } from 'library-components/utils/environment';
import qs from 'qs';
import { jumpTo } from '@/infrastructure/utils/jump';
import PtIcon from '@patsnap-biz/icon';
function makeCarsiForm() {
    return {
        display_name: '',
    };
}
let SSOLoginImpl = class SSOLoginImpl extends Vue {
    constructor() {
        super(...arguments);
        this.idpLoading = false;
        this.IDPS = [];
        this.formCarsi = makeCarsiForm();
        this.isLoadingValue = isLoadingValue;
    }
    checkIDPDisplayName(rule, value, callback) {
        if (this.idpLoading) {
            return callback();
        }
        // submit按钮不可选择, 这里就不报错了
        if (!value) {
            return callback();
        }
        const item = _.find(this.IDPS, idp => {
            return idp.display_name === value;
        });
        if (item) {
            return callback();
        }
        else {
            const msg = this.$t('passport.organization_not_found');
            return callback(new Error(msg));
        }
    }
    get CarsiRules() {
        return {
            display_name: [{
                    validator: this.checkIDPDisplayName,
                    trigger: 'blur',
                }],
        };
    }
    get IsIDPSEmpty() {
        return _.isEmpty(this.IDPS);
    }
    get SuggestCarsiClass() {
        return this.idpLoading ? 'idps-suggestion is-loading' : 'idps-suggestion';
    }
    // 二次检查CarsiRules#display_name#blur时候value是原来的值
    onSelectCarsi() {
        this.formCarsiRef.validate().catch(_.noop);
    }
    /**
     * 1. 字数限制 公司带中文 大于等于2个字符 ， 不带中文 大于等于4个字符，不满不搜索
     * 2. 常用词过滤（不进行搜索） '公司' '大学' 等值
     * @param query
     * @param cb
     */
    queryIDPS(query, cb) {
        this.IDPS = [];
        const value = _.trim(query);
        if (value === '') {
            // eslint-disable-next-line node/no-callback-literal
            cb([]);
            return false;
        }
        /** 是否满足字数要求 */
        let isSuitWordNumber = false;
        /** 是否满足关键字眼球 */
        let isSuitCorrectWord = false;
        const ignoreWordList = ['公司', '大学'];
        const wordLimitNumber = 1;
        console.log(value?.length, wordLimitNumber);
        if (value?.length >= wordLimitNumber) {
            isSuitWordNumber = true;
        }
        if (!_.includes(ignoreWordList, value)) {
            isSuitCorrectWord = true;
        }
        if (!isSuitWordNumber || !isSuitCorrectWord) {
            // eslint-disable-next-line node/no-callback-literal
            cb([]);
            return false;
        }
        this.idpLoading = true;
        this.IDPS = withLoadingValue(this.IDPS);
        cb(this.IDPS);
        getQueryIdpsApi(query).then(res => {
            this.IDPS = res || [];
        }).finally(() => {
            this.idpLoading = false;
            this.IDPS = withoutLoadingValue(this.IDPS);
            cb(this.IDPS);
        });
    }
    onClickIdpLogin() {
        this.$emit('reset');
        this.formCarsiRef.validate(validated => {
            if (!validated) {
                return;
            }
            const item = _.find(this.IDPS, idp => {
                return idp.display_name === this.formCarsi.display_name;
            });
            saveSelectedIDP(item);
            if (item) {
                const redirect_uri = getVar('redirect_uri');
                const [host, searchUrl] = item.login_url.split('?');
                const queryData = qs.parse(searchUrl, { ignoreQueryPrefix: true });
                const queryStr = qs.stringify({
                    ...queryData,
                    redirect_uri,
                }, {
                    skipNulls: true,
                });
                const href = `${host}?${queryStr}`;
                jumpTo(href);
            }
        });
    }
    created() {
        const IDPS = restoreSelectedIDP();
        if (_.size(IDPS) >= 1) {
            this.IDPS = IDPS;
            this.formCarsi.display_name = IDPS[0].display_name;
        }
    }
};
__decorate([
    Inject('commonService'),
    __metadata("design:type", Object)
], SSOLoginImpl.prototype, "commonService", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], SSOLoginImpl.prototype, "formCarsiRef", void 0);
SSOLoginImpl = __decorate([
    Component({
        components: {
            PtIcon,
        },
    })
], SSOLoginImpl);
export { SSOLoginImpl };
